<template>
    <h3>Please wait....</h3>
</template>

<script>

export default {
  name: "AuthCallback",
  mounted() {
    if (window.location.href.includes(process.env.VUE_APP_REDIRECT_URL)) {
        this.$router.push('/');
    }
  },
};
</script>
